export function stringToEnum<T>(enumEntity: Record<string | number, string | number>, value: string | number): T {
    if (value !== undefined && value !== null && Object.values(enumEntity).includes(value)) {
        return value as T;
    }
    throw new Error(`${value} is not a part of enum ${JSON.stringify(Object.values(enumEntity))}`);
}
